module.exports = __webpack_public_path__ + "img/steedmunds750x750.e70f175a.jpg";